// import './wdyr.ts';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {register} from './serviceWorkerRegistration';
import './i18n';
import './sentry';
import {ErrorBoundary} from '@sentry/react';
import Error from './pages/Error';
import './polyfill';
import MatomoAppProvider from './components/MatomoAppProvider';
import {
    customCustomerSubDomain,
    getLocation,
    isProfileUrl,
} from './lib/urlHelper';
import {isInMobileApp} from './lib/mobileAppBridge';
import {installFormEnterKeyNavigation} from './lib/formEnterKey';

if (isInMobileApp()) {
    installFormEnterKeyNavigation();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ErrorBoundary fallback={({error}) => <Error error={error as Error} />}>
            <MatomoAppProvider>
                <App />
            </MatomoAppProvider>
        </ErrorBoundary>
    </React.StrictMode>,
);

const profile = isProfileUrl(getLocation().toString());
register({
    profile,
    // A customer subdomain serves both apps: its profile worker is scoped to profile pages so
    // that it coexists with the dashboard one instead of replacing it on every visit.
    scope: profile && customCustomerSubDomain ? '/p/' : undefined,
});
